import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'rm-contact',
  template: `    
    <!--<div class="jumbotron">-->
      <!--<form #form="ngForm" (ngSubmit)="submitForm(form.value)">-->
        <!--<div class="form-group">-->
          <!--<label>First Name:</label>-->
          <!--<input type="text" class="form-control" placeholder="Name" name="name" ngModel required>-->
        <!--</div>-->
        <!--<div class="form-group">-->
          <!--<label>Email</label>-->
          <!--<input type="email" class="form-control" placeholder="Email" name="email" ngModel required>-->
        <!--</div>-->
        <!--<div class="form-group">-->
          <!--<label for="comment">Comment:</label>-->
          <!--<textarea class="form-control" rows="5" name="comment"></textarea>-->
        <!--</div>-->
        <!---->
        <!--<div class="form-group">-->
          <!--<button type="submit" class="btn btn-default">Submit</button>-->
        <!--</div>-->
      <!--</form>-->
    <!--</div>-->
  `,
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  submitForm(val) {
    console.log(val);
  }
}



// WEBPACK FOOTER //
// ./src/app/contact/contact.component.ts